import { render } from "./CouncilPage.vue?vue&type=template&id=93b50058"
import script from "./CouncilPage.vue?vue&type=script&lang=js"
export * from "./CouncilPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__